<template>
  <v-text-field
    outlined
    dense
    class="rounded-lg mt-1 mini-text field-edit"
    :label="keyValue"
    :clearable="true"
    :value="modelValue"
    :hide-details="hideDetails"
    @input="$emit('input', getNormalizedNumberFromString($event) || null)"
    @click:clear="$emit('input', null)"
  />
</template>

<script>
import { getNormalizedNumberFromString } from '@/scripts/getNormalizedNumberFromString'

export default {
  name: 'FlaotInput',
  props: {
    modelValue: { type: String | null, required: true },
    hideDetails: {type: Boolean, default: false},
    keyValue: { type: String, required: true },
  },

  methods: { getNormalizedNumberFromString },
}

</script>
